import { render, staticRenderFns } from "./ti9.vue?vue&type=template&id=4c617536&scoped=true&"
import script from "./ti9.vue?vue&type=script&lang=js&"
export * from "./ti9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c617536",
  null
  
)

export default component.exports